<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
import store from '@/store'
export default {
  name: 'App',
  // created() {
  //   //在页面刷新时将vuex里的信息保存到localStorage里

  //   window.addEventListener("beforeunload", () => {
  //     // debugger
  //     console.log(store.getters.token)
  //     localStorage.setItem("store", JSON.stringify(store))

  //   })

  //   //在页面加载时读取localStorage里的状态信息
  //   // debugger
  //   console.log(store.getters.token)
  //   localStorage.getItem("store") && store.replaceState(Object.assign(store, JSON.parse(
  //     localStorage.getItem("store"))));
  //     console.log(store.getters.token)

  // }
}

</script>

<style>
html,
body {
  background-color: #f3f3f3;
  height: 100%;
}

#app {
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

.BMap_cpyCtrl {
  display: none;
}

.anchorBL {
  display: none;
}

.body-img {
  background-image: url(http://trm-files.oss-cn-beijing.aliyuncs.com/pen/bj.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  background-position-y: -46px;
  background-attachment: fixed;
  height:auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue